import script from "./SensorExtractionsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./SensorExtractionsView.vue?vue&type=script&setup=true&lang=ts"

import "./SensorExtractionsView.vue?vue&type=style&index=0&id=332efc52&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-332efc52"]])

export default __exports__